<div fxLayout="column" class="pt-20" fxLayoutGap="20px">
    <div fxFlex fxLayoutAlign="center center" fxLayout="row">
        <div fxFlex fxLayoutAlign="center center">
            <button mat-fab color="primary" (click)="switchPage(pdfLinks.previous)" [disabled]="!pdfLinks.previous">
                <mat-icon style="width: 15px">arrow_back_ios</mat-icon>
            </button>
        </div>
        <div fxFlex fxLayoutAlign="center center">
            <button mat-fab color="primary" (click)="switchPage(pdfLinks.next)" [disabled]="!pdfLinks.next">
                <mat-icon>arrow_forward_ios</mat-icon>
            </button>
        </div>
    </div>
    <div fxFlex fxFill>
        @if (pdfLinks.downloadLink) {
            <pdf-viewer
                [src]="pdfLinks.downloadLink"
                [render-text]="true"
                [original-size]="false"
                [zoom-scale]="'page-height'"
                [fit-to-page]="true"
                [autoresize]="true"
                style="display: block; height: calc(100vh - 100px); max-width: 100vw"
            >
            </pdf-viewer>
        }
    </div>
</div>
